module.exports = __webpack_public_path__ + "img/industrial_vehicles-icon0.0a63b423.png";